export default __webpack_public_path__ + "static/media/zapper-logo-red-mark.43faaa58.svg";